import { useState, useRef, useCallback, useEffect } from 'react';
export const useTimer = () => {
  const [elapsedTime, setElapsedTime] = useState(0);
  const [currentTime, setCurrentTime] = useState(Date.now());
  const [isRunning, setIsRunning] = useState(false);
  const timeoutRef = useRef(undefined);
  const startTimeRef = useRef(0);
  const accumulatedTimeRef = useRef(0);
  const isRunningRef = useRef(false);
  const updateElapsedTime = useCallback(() => {
    const now = Date.now();
    const currentElapsed = accumulatedTimeRef.current + (now - startTimeRef.current);
    setElapsedTime(Math.floor(currentElapsed / 1000));
    setCurrentTime(now);
    if (isRunningRef.current) {
      timeoutRef.current = window.setTimeout(updateElapsedTime, 100);
    }
  }, []);
  const start = useCallback(() => {
    if (!isRunningRef.current) {
      setIsRunning(true);
      isRunningRef.current = true;
      startTimeRef.current = Date.now();
      updateElapsedTime();
    }
  }, [updateElapsedTime]);
  const stop = useCallback(() => {
    if (isRunningRef.current) {
      setIsRunning(false);
      isRunningRef.current = false;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
      }
      accumulatedTimeRef.current += Date.now() - startTimeRef.current;
    }
  }, []);
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
      }
    };
  }, []);
  return {
    elapsedTime,
    currentTime,
    isRunning,
    start,
    stop
  };
};